import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ContactModel from "../../models/contact";

export default class ContactRepository extends BaseRepository {
  static modelClass = ContactModel;
  modelName = "contact";

  async query(id, params) {
    return await super.query({
      urlPath: "case/" + id + "/contacts/?" + qs.stringify(params),
    });
  }

  async patch(id, data) {
    return await super.patch(data.id, data, {
      urlPath: "case/" + id + "/contacts/" + data.id,
    });
  }

  async createRecord(id, data) {
    const relation_type = data.relationType;
    if ("relationType" in data) {
      delete data.relationType;
    }
    const basePath = `case/${id}/contacts/`;
    const queryString = qs.stringify({ relation_type });
    const urlPathWithQueryParams = `${basePath}?${queryString}`;
    return await super.createRecord(data, { urlPathWithQueryParams });
  }

  async delete(id, contactId) {
    return await super.delete(contactId, {
      urlPath: "case/" + id + "/contacts",
    });
  }
}
